import { useTranslation } from 'react-i18next';
import { useSystemStore } from '@/store/systemStore';

/**
 * T3152 — logotip na javnih straneh aplikacije (prijava, registracija …) je
 * povezava na domačo stran spletne strani tega okolja (`website_url` iz
 * `GET /config/`); v angleščini na `/en/`. Brez naslova ostane slika.
 */
export default function WebsiteLogo({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  // Brez izbirnika, kot strani okoli njega — testne zamenjave trgovine vrnejo
  // cel objekt in izbirnika ne upoštevajo.
  const { settings } = useSystemStore();
  const websiteUrl = typeof settings?.website_url === 'string' ? settings.website_url : '';
  const logo = <img src="/logo.svg" alt="BuildPoint" className={className} />;
  if (!websiteUrl) return logo;
  const home = `${websiteUrl.replace(/\/+$/, '')}/${i18n.language === 'en' ? 'en/' : ''}`;
  return (
    <a href={home} aria-label={t('common.website_home')} className="inline-flex rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--bp-accent)]">
      {logo}
    </a>
  );
}
